import { render, staticRenderFns } from "./programSetupListing.vue?vue&type=template&id=dcea31d2&"
import script from "./programSetupListing.vue?vue&type=script&lang=js&"
export * from "./programSetupListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports